type CTASectionProps = {
  headline: string
  subheadline: string
  ctaText: string
  ctaLink: string
}

export default function CTASection({
  headline,
  subheadline,
  ctaText,
  ctaLink,
}: CTASectionProps) {
  return (
    <section className="py-16 bg-brand-green text-white">
      <div className="container-custom text-center">
        <h2 className="text-3xl font-bold mb-4">{headline}</h2>
        <p className="text-xl mb-8 opacity-90">{subheadline}</p>
        <a
          href={ctaLink}
          className="inline-block bg-white text-gray-900 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
        >
          {ctaText}
        </a>
      </div>
    </section>
  )
}
